import IdealPayment from "./IdealPayment";
export default IdealPayment;
